export default __webpack_public_path__ + "static/media/pro360.4fd9373c.jpg";